module.exports = __webpack_public_path__ + "img/iot_record3.33a3b719.png";